export enum RequestPermissionNotificationType {
    DiscountPermission = 1,
    SaleRefundPermission = 2,
    EditBillPermission = 3,
    CancelBookingPermission =4
}
